import { render } from "./MessageHighlight.vue?vue&type=template&id=596256c2&scoped=true"
import script from "./MessageHighlight.vue?vue&type=script&lang=js"
export * from "./MessageHighlight.vue?vue&type=script&lang=js"

import "./MessageHighlight.vue?vue&type=style&index=0&id=596256c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596256c2"],['__file',"src/scripts/common/components/MessageHighlight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "596256c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('596256c2', __exports__)) {
    api.reload('596256c2', __exports__)
  }
  
  module.hot.accept("./MessageHighlight.vue?vue&type=template&id=596256c2&scoped=true", () => {
    api.rerender('596256c2', render)
  })

}


export default __exports__